import styled from 'styled-components';
import { matchScreen, paddingRight } from '@Utils/layout/layoutSupport';
import { BodyM, BodyS, TitleBold } from '@Components/Typography/Typography.styled';

export const ContactDetailsWrapper = styled.div<{ simplifiedCheckout: boolean | undefined }>`
	${({ simplifiedCheckout }) => {
		const isXs = matchScreen('xs');

		if (simplifiedCheckout) {
			return {
				padding: 16,
			};
		} else if (isXs) {
			return {
				padding: 0,
			};
		} else {
			return {
				padding: '8px 16px 8px 32px',
			};
		}
	}}
`;

export const Heading = styled(BodyM)`
	${({ theme }) => ({ color: theme.colors.black87 })}
	${({ theme }) => theme.typography.paragraphMBold}
	margin-bottom: 10px;
`;

export const HeaderWrapper = styled.div`
	display: flex;
`;

export const Subtitle = styled(BodyS)`
	${({ theme }) => ({
		color: theme.colors.black54,
	})}
`;

export const IconWrapper = styled.div`
	${() => paddingRight(16)}
`;

export const ButtonsWrapper = styled.div`
	margin-top: 32px;
`;

export const FormWrapper = styled.div<{ simplifiedCheckout: boolean | undefined }>`
	${({ simplifiedCheckout }) => {
		const isXs = matchScreen('xs');
		if (simplifiedCheckout && !isXs) {
			return {
				marginLeft: 42,
			};
		}
	}}

	${() =>
		matchScreen('xs') && {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'left',
		}}
`;
export const DatePickerFieldWrapper = styled.div`
	margin-bottom: 16px;
`;

export const TitleWrapper = styled(TitleBold)`
	${({ theme }) => `
    color: ${theme.colors.black87};
    margin: auto};
  `}
`;

export const TitleContainer = styled.div`
	${() => ({
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	})}
`;
